export default __webpack_public_path__ + "static/media/analysis.0f63d5e9.jpg";